import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import SelectPicker from '../../../components/SelectPicker';
import FormInput from '../../../components/FormInput';
import {ModelListSelect} from 'vue-search-select';

export default {
    components: {Datepicker, SelectPicker, FormInput, ModelListSelect},
    data() {
        return {
            date_from: null,
            date_to: null,
            cashiers: [],
            keyword: '',
            selectedCashier: null,
            result: [],
            all: {
                passengers_count: 0,
                passenger_amount: 0,
                services_count: 0,
                services_amount: 0,
                reversed_count: 0,
                reversed_amount: 0,
                ok_passenger_count: 0,
                ok_passenger_amount: 0,
                ok_passenger_bag_amount: 0,
                booked_count: 0,
            },
            loadingState: false,
            fromError: false,
            toError: false,
            inputClass: ['form-control base_input'],
        }
    },
    created() {
        this.loadCashiers();
    },
    computed: {
        startDate() {
            return this.$moment(this.date_from).startOf('day').format('Y-MM-DD');
        },
        endDate() {
            return this.$moment(this.date_to).endOf('day').format('Y-MM-DD')
        },
    },
    methods: {
        loadCashiers() {
            this.$api.get('reports.validatorsList').then(res => {
                this.cashiers = res.data;
            }).catch()
        },
        reportCustom() {
            if (this.date_from && this.date_to) {
                this.inputClass.splice(1, 1);
                this.makeRequest({
                    from: this.startDate,
                    to: this.endDate,
                    cashierId: this.selectedCashier
                });
            } else {
                if (!this.date_from) {
                    this.fromError = true;
                }
                if (!this.date_to) {
                    this.toError = true;
                }
                this.inputClass.push('is-invalid');
            }
        },
        makeRequest(params) {
            this.loadingState = true;
            this.$api.post('reports.validators', params).then(res => {
                this.result = res.data;
                this.calculateAll();
            }).finally(() => {
                this.loadingState = false;
            })
        },
        calculateAll() {

            this.all.today_passengers_count = this.result.reduce((sum, a) => sum + parseInt(a.today_passenger_count), 0);
            this.all.later_passengers_count = this.result.reduce((sum, a) => sum + parseInt(a.later_passenger_count), 0);
            this.all.passenger_cash_amount = this.result.reduce((sum, a) => sum + a.passenger_cash_amount, 0);
            this.all.passenger_terminal_amount = this.result.reduce((sum, a) => sum + a.passenger_terminal_amount, 0);
            this.all.services_count = this.result.reduce((sum, a) => sum + a.services_count, 0);
            this.all.services_amount = this.result.reduce((sum, a) => sum + a.services_amount, 0);
            this.all.reversed_count = this.result.reduce((sum, a) => sum + a.reversed_count, 0);
            this.all.reversed_amount = this.result.reduce((sum, a) => sum + a.reversed_amount, 0);
            this.all.ok_passenger_count = this.result.reduce((sum, a) => sum + a.ok_passenger_count, 0);
            this.all.ok_passenger_amount = this.result.reduce((sum, a) => sum + a.ok_passenger_amount, 0);
            this.all.ok_passenger_bag_amount = this.result.reduce((sum, a) => sum + a.ok_passenger_bag_amount, 0);
            this.all.booked_count = this.result.reduce((sum, a) => sum + a.booked_count, 0);

        },
        printData() {
            let fontSize = this.$refs.printTable.style.fontSize;
            this.$refs.printTable.style.fontSize = '13.5px';
            this.displayNoneLoop = false;
            let mywindow = window.open('', 'PRINT');
            mywindow.document.write('<html><head><title>' + document.title + '</title>');
            mywindow.document.write('<link rel="stylesheet" href="/css/lib.css" />');
            mywindow.document.write('<link rel="stylesheet" href="/css/app.css" />');
            mywindow.document.write('<link rel="stylesheet" href="/print.css" />');
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById('table').innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus();
            this.$refs.printTable.style.fontSize = fontSize;

            setTimeout(() => {
                mywindow.print();
                mywindow.close();
            }, 1000)
        },
        exportToExcel() {
            let fileName = 'Отчет_по_валидаторам_' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
            this.$api.download('xls.validatorReport', {
                fromDate: this.startDate,
                toDate: this.endDate,
                cashierId: this.selectedCashier,
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        reportMonthly() {
            var date = new Date();
            this.date_from = new Date(date.getFullYear(), date.getMonth(), 1);
            this.date_to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            this.reportCustom()
        },
        reportDaily() {
            this.date_from = new Date();
            this.date_to = new Date();
            this.reportCustom()
        }
    },
    mounted() {
    },
    filters: {
        moneyFormat(num) {
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        },
    }
}
